var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"calc(100vh - 200px)"}},[_c('span',[_vm._v("Check back later.")])])
}]

export { render, staticRenderFns }